export const EffectStatus = {
    /**
     * @constant
     * @type {number}
     */
    FINISHED_AND_AVAILABLE_FOR_CACHE: 1,
    /**
     * @constant
     * @type {number}
     */
    FINISHED_BUT_IN_USE: 2,
    /**
     * @constant
     * @type {number}
     */
    NOT_STARTED: 3,
    /**
     * @constant
     * @type {number}
     */
    STARTED_NOT_FINISHED: 4
};
